import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Inbox Fill
 */

export default function InboxFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M12.2229 3H3.30903C3.11964 3 2.94651 3.107 2.86181 3.27639L1.36181 6.27639C1.19559 6.60884 1.43733 7 1.80903 7H6.00001C6.00001 8.10457 6.89544 9 8.00001 9C9.10458 9 10 8.10457 10 7H14.0979C14.4906 7 14.73 6.56802 14.5219 6.235L12.6469 3.235C12.5555 3.08881 12.3953 3 12.2229 3ZM1.5 8H5.17071C5.58254 9.16519 6.69378 10 8 10C9.30622 10 10.4175 9.16519 10.8293 8H14.5C14.7761 8 15 8.22386 15 8.5V13.5C15 13.7761 14.7761 14 14.5 14H1.5C1.22386 14 1 13.7761 1 13.5V8.5C1 8.22386 1.22386 8 1.5 8Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
